import Lines from '../components/common/Lines';
import ProgressScroll from '../components/common/ProgressScroll';
import Cursor from '../components/common/cusor';
import LoadingScreen from '../components/common/loader';
import Footer from '../components/common/Footer';
import Navbar from '../components/common/Navbar';
import Marq2 from '../components/common/Marq2';
import { Helmet } from 'react-helmet';
import FaviconLinks from '../components/common/FaviconLinks';
import TemplatesList from '../components/page-templates/TemplatesList';
import WOW from 'wowjs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { useEffect, useRef } from 'react';
gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function PageTemplates() {
  const main = useRef();
  const smoother = useRef();

  useEffect(() => {
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve(true);
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.body.appendChild(script);
      });
    };

    loadScript('/assets/js/gsap.min.js')
      .then(() => loadScript('/assets/js/ScrollSmoother.min.js'))
      .then(() => loadScript('/assets/js/smoother-script.js'))
      .catch((error) => console.error(error.message));
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      new WOW.WOW({ animateClass: 'animated', offset: 100 }).init();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Web Şablonları — Kanus Digital</title>
        <meta name="description" content="Profesyonel web şablonları: Kurumsal, e-ticaret, portfolyo ve daha fazlası. Kanus Digital'in hazır web site şablonlarını inceleyin." />
        <meta name="keywords" content="web şablonları, hazır web sitesi, kurumsal şablon, e-ticaret şablonu, portfolyo şablonu, HTML şablon" />
        <meta name="robots" content="index, follow" />
        <meta property="og:url" content="https://kanusdigital.com/sablonlar" />
        <meta property="og:title" content="Web Şablonları — Kanus Digital" />
        <meta property="og:description" content="Profesyonel hazır web şablonları. Kurumsal, e-ticaret ve portfolyo şablonları." />
        <link rel="canonical" href="https://kanusdigital.com/sablonlar" />
        <FaviconLinks />
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@200;300;400;500;600;700&display=swap"
        />
        <script src="/assets/js/ScrollTrigger.min.js" defer />
        <script src="/assets/js/ScrollSmoother.min.js" defer />
        <script defer src="/assets/js/gsap.min.js"></script>
        <script defer src="/assets/js/splitting.min.js"></script>
        <script defer src="/assets/js/isotope.pkgd.min.js"></script>
        <script defer src="/assets/js/plugins.js"></script>
        <script defer src="/assets/js/TweenMax.min.js"></script>
        <script defer src="/assets/js/charming.min.js"></script>
        <script defer src="/assets/js/countdown.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <Navbar />
        <div id="smooth-wrapper" ref={main}>
          <div id="smooth-content">
            <main className="main-bg o-hidden">
              <div
                className="main-header valign"
                style={{
                  background: 'linear-gradient(135deg, #0a0a0a 0%, #111 100%)',
                  padding: '120px 0 80px',
                  borderBottom: '1px solid rgba(255,255,255,0.06)',
                }}
              >
                <div className="container">
                  <div className="row">
                    <div className="col-lg-8">
                      <div className="caption">
                        <span className="sub-title main-color mb-15 d-block">
                          Kanus Digital
                        </span>
                        <h1 className="fw-700">Web Şablonları</h1>
                        <p className="mt-20 p-color fz-16" style={{ maxWidth: '500px' }}>
                          Projeleriniz için hazır, modern ve özelleştirilebilir
                          web şablonları. URL ve kapak resmiyle kolayca ekleyin.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <TemplatesList />
              <Marq2 />
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
